"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketService = void 0;
const environment_1 = require("@environment/environment");
class WebSocketService {
    constructor($rootScope, webSocketKeepAliveBrokerService, webSocketKeepAliveService) {
        this.$rootScope = $rootScope;
        this.webSocketKeepAliveBrokerService = webSocketKeepAliveBrokerService;
        this.webSocketKeepAliveService = webSocketKeepAliveService;
    }
    static factory($rootScope, webSocketKeepAliveBrokerService, webSocketKeepAliveService) {
        return new WebSocketService($rootScope, webSocketKeepAliveBrokerService, webSocketKeepAliveService);
    }
    messageType(message) {
        const msg = this.messageToObject(message);
        if ('reason' in msg && msg.reason == 'keep-alive') {
            return 'keep-alive';
        }
        else if ('Status' in msg && 'updateStatus' in msg) {
            return 'status';
        }
        return undefined;
    }
    messageToObject(message) {
        const messageParts = message.split(',');
        const result = {};
        for (var i = 0; i < messageParts.length; i++) {
            const part = messageParts[i];
            const items = part.split('=');
            if (items.length > 1) {
                result[items[0]] = items[1];
            }
        }
        return result;
    }
    get socket() {
        return this.$rootScope.socket;
    }
    set socket(socket) {
        this.$rootScope.socket = socket;
    }
    connect(agentId, firstName, lastName, onopen, onmessage, onerror, onclose) {
        if (!this.socket || (this.socket.readyState !== WebSocket.OPEN && this.socket.readyState !== WebSocket.CONNECTING)) {
            console.log('socket golive : here');
            // A CLOSING (or already CLOSED) socket may still fire its close event
            // AFTER we replace it below. Detach its handlers so that late event
            // cannot run reconnect logic or mutate state belonging to the new
            // connection, and stop its keep-alive loop so the new socket's onopen
            // can start a fresh one.
            if (this.socket) {
                this.socket.onopen = null;
                this.socket.onmessage = null;
                this.socket.onerror = null;
                this.socket.onclose = null;
                this.webSocketKeepAliveService.stop();
            }
            const socket = new WebSocket(`${environment_1.environment.socketUrl}?agentId=${agentId}`);
            this.socket = socket;
            const openTimeout = window.setTimeout(() => {
                if (this.socket === socket && socket.readyState === WebSocket.CONNECTING) {
                    console.error('[AgentStatusWS] Connection attempt timed out');
                    socket.close(4001, 'connect-timeout');
                }
            }, 15000);
            // Set up event handlers
            socket.onopen = (event) => {
                window.clearTimeout(openTimeout);
                if (this.socket !== socket) {
                    return;
                }
                this.webSocketKeepAliveBrokerService.init(socket);
                this.webSocketKeepAliveService.start(agentId, firstName, lastName);
                onopen(event);
            };
            socket.onmessage = (event) => {
                if (this.socket === socket) {
                    onmessage(event);
                }
            };
            socket.onerror = (event) => {
                if (this.socket === socket) {
                    onerror(event);
                }
            };
            socket.onclose = (event) => {
                window.clearTimeout(openTimeout);
                if (this.socket === socket) {
                    this.webSocketKeepAliveService.stop();
                }
                onclose(event);
            };
        }
    }
    discard() {
        const socket = this.socket;
        this.webSocketKeepAliveService.stop();
        if (!socket) {
            return;
        }
        socket.onopen = null;
        socket.onmessage = null;
        socket.onerror = null;
        socket.onclose = null;
        try {
            socket.close(1000, 'client-reset');
        }
        catch (_) { }
        if (this.socket === socket) {
            this.$rootScope.socket = null;
        }
    }
    disconnect() {
        if (this.socket) {
            if (this.socket.readyState == WebSocket.OPEN) {
                // Explicit 1000 (normal closure): without a code the close event can
                // surface as 1005 and be mistaken for an abnormal drop by the
                // dashboard's reconnect logic.
                this.socket.close(1000, 'client-disconnect');
            }
            else if (this.socket.readyState == WebSocket.CONNECTING) {
                this.socket.close(1000, 'client-disconnect');
            }
            else {
                console.error('WebSocket is not connected or already closed.');
            }
        }
        else {
            console.error('WebSocket is not initialized.');
        }
    }
}
exports.WebSocketService = WebSocketService;
angular.module('callX').service('WebSocketService', [
    '$rootScope',
    'WebSocketKeepAliveBrokerService',
    'WebSocketKeepAliveService',
    WebSocketService.factory,
]);
